<template>
  <div class="flex items-center justify-center gap-3 text-xs text-red-600">
    <span>{{ message }}</span>
    <button v-if="retryable" type="button" class="btn-secondary-sm" @click="$emit('retry')">
      Retry
    </button>
  </div>
</template>

<script>
import { LOAD_ERROR_MESSAGE } from '@/utils/loadError.js'

// Inline error state for a failed load. Pass `retryable` only for reads likely to recover;
// never retry a request that changes data.
export default {
  name: 'LoadError',
  props: {
    message: { type: String, default: LOAD_ERROR_MESSAGE },
    retryable: { type: Boolean, default: false },
  },
  emits: ['retry'],
}
</script>
